'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, FC, ReactNode, useContext, useMemo } from 'react';
import { ScheduleEntry } from '@ordering/types/Schedule';
import { useStorefrontConfig } from '@ordering/providers/StorefrontConfig/StorefrontConfig';
import { getCurrentScheduleEntry } from '@ordering/providers/ScheduleProvider/getCurrentSchedule';
const ScheduleContext = createContext<{
  currentOrNextSchedule: ScheduleEntry;
  hours: {
    starts: string;
    ends: string;
    day: string;
  };
  isCurrentlyOpen: boolean;
  isOpenToday: boolean;
  isOpenTomorrow: boolean;
  timezone: string;
}>({} as any);
export const ScheduleProvider: FC<{
  children: ReactNode;
}> = t0 => {
  const $ = _c(13);
  const {
    children
  } = t0;
  const {
    schedule,
    details: t1,
    orderPreferences
  } = useStorefrontConfig();
  const {
    timezone
  } = t1;
  let t2;
  if ($[0] !== schedule || $[1] !== timezone) {
    t2 = getCurrentScheduleEntry(schedule, timezone);
    $[0] = schedule;
    $[1] = timezone;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    currentOrNextSchedule,
    hours,
    isCurrentlyOpen,
    isOpenToday,
    isOpenTomorrow
  } = t2;
  let t3;
  if ($[3] !== currentOrNextSchedule || $[4] !== hours || $[5] !== isCurrentlyOpen || $[6] !== isOpenToday || $[7] !== isOpenTomorrow || $[8] !== timezone) {
    t3 = {
      currentOrNextSchedule,
      hours,
      isCurrentlyOpen,
      isOpenToday,
      isOpenTomorrow,
      timezone
    };
    $[3] = currentOrNextSchedule;
    $[4] = hours;
    $[5] = isCurrentlyOpen;
    $[6] = isOpenToday;
    $[7] = isOpenTomorrow;
    $[8] = timezone;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const value = t3;
  let t4;
  if ($[10] !== children || $[11] !== value) {
    t4 = <ScheduleContext.Provider value={value}>{children}</ScheduleContext.Provider>;
    $[10] = children;
    $[11] = value;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
export const useSchedule = () => {
  return useContext(ScheduleContext);
};